import {CallHomeRequests} from '../../../../values/call-home-request'
import {ChrState} from './chr-state'

export const DEFAULT_CHR_STATE: ChrState = {
    callHomeRequest: {} as CallHomeRequests,
    terminalExpanded: false,
    selectedTabIndex: 0,
    showCloseTerminalModal: false,
}
